const statusResolver = (item: any): number =>
  item?.status ?? item?.response?.status ?? 0

export default statusResolver
